import html2canvas from 'html2canvas';
import { toast } from 'sonner';
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { saveBase64ToDevice } from './deviceSave';

const isNative = Capacitor.isNativePlatform();
const toBase64 = (canvas) => canvas.toDataURL('image/jpeg', 0.85).split(',')[1];
const isAbort = (e) => e?.name === 'AbortError' || /cancel|abort/i.test(e?.message || '');

// Renders an off-screen node to a canvas (node must be mounted).
export const captureNode = async (node, { width = 430, scale = 2 } = {}) => {
  if (!node) return null;
  return html2canvas(node, { backgroundColor: '#141414', scale, useCORS: true, allowTaint: true, logging: false, width });
};

// Opens the native/web share sheet with the image + text (text-only fallback).
export const shareCanvas = async (canvas, text, fileBase = 'rvincente') => {
  const fileName = `${fileBase}-${Date.now()}.jpg`;
  try {
    if (isNative) {
      const { Share } = await import('@capacitor/share');
      try {
        await Filesystem.writeFile({ path: fileName, data: toBase64(canvas), directory: Directory.Cache });
        const { uri } = await Filesystem.getUri({ directory: Directory.Cache, path: fileName });
        await Share.share({ text, files: [uri], dialogTitle: 'Condividi' });
      } catch (e) {
        if (isAbort(e)) return;
        await Share.share({ text, dialogTitle: 'Condividi' });
      }
      return;
    }
    const blob = await new Promise((r) => canvas.toBlob(r, 'image/jpeg', 0.85));
    const file = blob && new File([blob], fileName, { type: 'image/jpeg' });
    if (file && navigator.canShare?.({ files: [file] })) await navigator.share({ text, files: [file] });
    else if (navigator.share) await navigator.share({ text });
    else { await navigator.clipboard.writeText(text); toast.success('Testo copiato: incollalo dove vuoi!'); }
  } catch (e) {
    if (!isAbort(e)) toast.error('Errore nella condivisione');
  }
};

// Saves the image to Gallery (native plugin) or downloads it (web).
export const saveCanvas = async (canvas, fileBase = 'rvincente') => {
  const fileName = `${fileBase}-${Date.now()}.jpg`;
  if (isNative) {
    if (await saveBase64ToDevice(toBase64(canvas), fileName, 'image/jpeg')) return;
    await shareCanvas(canvas, 'La mia selezione RVINCENTE', fileBase);
    return;
  }
  const a = document.createElement('a');
  a.href = canvas.toDataURL('image/jpeg', 0.9);
  a.download = fileName;
  a.click();
  toast.success('Immagine scaricata');
};
